//PDF
import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { Button } from "antd";
import ReportV120 from "./reportV120";
import ReportV180 from "./reportV180";
import ReportR120 from "./reportR120";
import ReportR180 from "./reportR180";
import ReportV270 from "./reportV270";
import ReportR270 from "./reportR270";
function SearchPDF({ dataDay, dataType, tableGroup, sumCountGroup}) {
 console.log("dataDay", dataDay);
  const [triggerPDF, setTriggerPDF] = useState(false);
  const conponentPDF = useRef();
  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "รายงานสืบทรัพย์ก่อนฟ้อง",
  });

  const handlePDF = () => {
    setTriggerPDF(true); // ตั้ง triggerPDF ที่นี่หลังจากได้รับข้อมูล
  };
  //โหลด PDF
  useEffect(() => {
    if (triggerPDF) {
      generatePDF();
      setTriggerPDF(false); // Reset the trigger
    }
  }, [triggerPDF, generatePDF]);

  return (
    <>
      <Button type="primary" onClick={() => handlePDF()} danger>
        พิมพ์
      </Button>
      <div className="print-only" ref={conponentPDF} justify={"center"}>
        {dataDay && dataDay === "120" && dataType === "vsfhp" ? <ReportV120 tableGroup={tableGroup} sumCountGroup={sumCountGroup} /> : []}
        {dataDay && dataDay === "180" && dataType === "vsfhp" ? <ReportV180 tableGroup={tableGroup} sumCountGroup={sumCountGroup} /> : []}
        {dataDay && dataDay === "270" && dataType === "vsfhp" ? <ReportV270 tableGroup={tableGroup} sumCountGroup={sumCountGroup} />: []} 
        {dataDay && dataDay === "120" && dataType === "rpsl" ? <ReportR120 tableGroup={tableGroup} sumCountGroup={sumCountGroup} /> : []}
        {dataDay && dataDay === "180" && dataType === "rpsl" ? <ReportR180 tableGroup={tableGroup} sumCountGroup={sumCountGroup} /> : []}
        {dataDay && dataDay === "270" && dataType === "rpsl" ? <ReportR270 tableGroup={tableGroup} sumCountGroup={sumCountGroup} />: []} 
      </div>
    </>
  );
}
export default SearchPDF;
